import { HolidaysRegisterTemplate } from "../../Templates/HolidaysRegisterTemplate";

export const HolidaysRegister = () => {
  return <HolidaysRegisterTemplate />;
};
